import React from 'react';
import PropTypes from 'prop-types';

import SubNavigation from "./SubNavigation";
import Constants from "../utils/Constants";

function PatternsTabs(props) {
	let {tabClicked, selectedTab, setBannerClassName, hasNudgeBanner} = props;

	const tabs = [{
		label: "Active",
		value: Constants.PATTERN.STATUSES.ACTIVE,
		hasAccess: true
	},{
		label: "Inactive",
		value: Constants.PATTERN.STATUSES.INACTIVE,
		hasAccess: true
	}];

	return (
		<SubNavigation
			tabs={tabs}
			title="Patterns"
			//selectFieldId="patternsbutton"
			selectedTab={selectedTab}
			tabClicked={tabClicked}
			hasNudgeBanner={hasNudgeBanner}
			setBannerClassName={setBannerClassName} />
	);
}

PatternsTabs.propTypes = {
	hasNudgeBanner: PropTypes.bool,
	tabClicked: PropTypes.func.isRequired,
	setBannerClassName: PropTypes.func.isRequired,
	selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired
};

export default PatternsTabs;